<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal title="完善信息" :width="800" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit" @cancel="handleCancel" :maskClosable="false">
    <template #footer>
      <a-button key="back" @click="handleCancel">取消</a-button>
      <a-button key="submit" type="primary" :loading="state.loading" @click="onFormSubmit">提交认证</a-button>
    </template>
    <a-spin :spinning="state.loading">
      <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
        <a-form-item label="用户名" name="nickname" required>
          <a-input placeholder="请输入" v-model:value="formState.nickname"></a-input>
        </a-form-item>
        <a-form-item label="手机号" name="phone" required>
          <a-input
            placeholder="手机号码"
            @change="
              (v) => {
                phoneChange(v, 'phone')
              }
            "
            v-model:value="formState.phone"
          ></a-input>
        </a-form-item>
        <a-form-item label="验证码" name="captcha" required :rules="[{ required: true, message: '请输入验证码' }]">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <a-input placeholder="验证码" v-model:value="formState.captcha">
              <template #prefix>
                <LockOutlined :style="{ color: 'rgba(0,0,0,.25)' }" />
              </template>
            </a-input>
            <a-button type="primary" class="getCaptcha3" tabindex="-1" :disabled="state.smsSendBtn" @click.stop.prevent="getCaptcha3">{{
              (!state.smsSendBtn && '获取验证码') || state.time + ' s'
            }}</a-button>
          </div>
        </a-form-item>
        <a-divider orientation="left">为了保障您的用户权益，下列信息建议填上</a-divider>
        <a-form-item label="姓名" name="idcard_name">
          <a-input placeholder="姓名" v-model:value="formState.idcard_name"></a-input>
        </a-form-item>
        <a-form-item label="身份证" name="idcard_num">
          <a-input placeholder="身份证" v-model:value="formState.idcard_num"></a-input>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue'
import baseService from '@/utils/http/axios'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD'
const props = defineProps({
  userId: {
    type: Number,
    default: 0
  }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
  labelCol: {
    xs: { span: 7 },
    sm: { span: 7 }
  },
  wrapperCol: {
    xs: { span: 10 },
    sm: { span: 10 }
  }
}
interface state {
  loading: boolean
  smsSendBtn: boolean
  time: number
}
const state = reactive<state>({
  loading: false,
  smsSendBtn: false,
  time: 60
})
interface formState {
  nickname: ''
  phone: string
  idcard_name: string
  idcard_num: string
  captcha: string
}
let formState = reactive<formState>({
  nickname: '',
  phone: '',
  idcard_name: '',
  idcard_num: '',
  captcha: ''
})
onMounted(() => {
  queryDetail(props.userId)
})
const queryDetail = (id) => {
  state.loading = true
  let requeryParam = {
    url: '/admin/v1/userInfo',
    method: 'get'
  }
  baseService(requeryParam)
    .then((res) => {
      state.loading = false
      res.data.userinfo.starttime = dayjs(res.data.userinfo.starttime, format)
      res.data.userinfo.endtime = dayjs(res.data.userinfo.endtime, format)
      Object.assign(formState, res.data.userinfo)
    })
    .catch((res) => {
      if (res.msg) {
        message.error(res.msg)
      } else {
        console.debug(res)
        message.error('操作失败')
      }
      state.loading = false
    })
}
const phoneChange = (v, type) => {
  let str = v.target.value.replaceAll(/\D/g, '')
  formState[type] = str
}
const onFormSubmit = () => {
  ruleForm.value
    .validate()
    .then(() => {
      state.loading = true
      let requeryParam = {
        url: '/admin/v1/userWanshan',
        method: 'post',
        data: Object.assign({}, formState, { step: 2 })
      }
      baseService(requeryParam)
        .then((res: any) => {
          state.loading = false
          message.success(res.msg)
          emit('ok')
        })
        .catch((res) => {
          state.loading = false
          if (res.msg) {
            message.error(res.msg)
          } else {
            message.error('操作失败')
          }
        })
    })
    .catch(() => {})
}
const handleCancel = () => {
  emit('cancel')
}
const getCaptcha3 = () => {
  if (formState.phone == '') {
    message.error('请输入手机号')
    return
  }
  //判断手机号格式是否正确
  if (!/^1[3456789]\d{9}$/.test(formState.phone)) {
    message.error('请输入正确的手机号')
    return
  }
  state.smsSendBtn = true
  let interval = window.setInterval(() => {
    if (state.time-- <= 0) {
      state.time = 60
      state.smsSendBtn = false
      window.clearInterval(interval)
    }
  }, 1000)
  let requestParam = {
    url: '/admin/v1/userWanshan',
    method: 'post',
    data: {
      mobile: formState.phone,
      step: 1
    }
  }
  baseService(requestParam)
    .then((res: any) => {
      message.success('发送成功')
    })
    .catch((res) => {
      if (res.msg) {
        message.error(res.msg)
      } else {
        message.error('操作失败')
      }
    })
}
</script>

<style lang="less" scoped></style>
